export enum ApiTag {
  ActiveSites = 'ActiveSites',
  CaseDetails = 'CaseDetails',
  CaseTypes = 'CaseTypes',
  RecentCasesBySite = 'RecentCasesBySite',
  User = 'User',
}
